(function () {
    'use strict';

    angular.module("imApp").factory("textileStockSearchService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1467,
                    parameters: parms || {}
                });
            },
            listTextileStocks: function (parms) {
                return $ihttp.post({
                    method: 1468,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
